export default __webpack_public_path__ + "static/media/wallet.e79f0e8d.svg";